import { Component, OnInit,ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CampaignService } from '../../../services/campaign/campaign.service';
import { Campaign } from '../new-campaign/campaign';
import { Observable } from 'rxjs/Observable';


@Component({
  selector: 'campaign-summary',
  templateUrl: './summary.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [ CampaignService ],
  styles: ['#customer-chart g.highcharts-stack-labels { display: none}']
})
export class SummaryComponent implements OnInit
{
  public campaign: Campaign;
  public spentBudget: number;
  public budgetPercentage: number = 0;
  public totalCustomers = 0;
  public coupons: any[];
  public chartTab: number = 1;

  public charts = {
    summary: { instance: null, options: null },
    costPerType: { instance: null, options: null },
    costPerChannel: { instance: null, options: null }
  };

  constructor(
    private campaignService: CampaignService,
    private route: ActivatedRoute
  ) {
    const colors = ['#2c689a', '#3392ba', '#36bedb', '#33ebfd', '#8085e9'];

    this.charts.summary.options = {
      chart: {
        type: 'bar'
      },
      title: {
        text: ''
      },
      xAxis: {
        categories: [],
        title: {
          text: ''
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: 'customers',
          align: 'high'
        },
        labels: {
          overflow: 'justify'
        },
        stackLabels: {
          enabled: true
        }
      },
      plotOptions: {
        series: {
          stacking: 'normal'
        }
      },
      legend: {
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'top',
        x: -30,
        y: 0,
        floating: true,
        borderWidth: 1,
        backgroundColor: '#FFFFFF',
        shadow: false
      },
      series: [
        { name: '', color: colors[0], data: [] },
        { name: '', color: colors[1], data: [] },
      ],
    };

    this.charts.costPerType.options = {
      chart: {
        type: 'pie',
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false
      },
      title: {
        text: ''
      },
      tooltip: {
        valueSuffix: '%'
      },
      colors: colors,
      series: [{
        name: 'Cost per type',
        colorByPoint: true,
        data: []
      }],
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        }
      }
    };

    this.charts.costPerChannel.options = {
      chart: {
        type: 'bar'
      },
      title: {
        text: ''
      },
      xAxis: {
        categories: [],
        title: {
          text: ''
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: 'budget',
          align: 'high'
        },
        labels: {
          overflow: 'justify'
        },
        stackLabels: {
          enabled: true,
          formatter: function () {
            return this.total + '€';
          }
        }
      },
      plotOptions: {
        series: {
          stacking: 'normal'
        }
      },
      legend: {
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'top',
        x: -30,
        y: 0,
        floating: true,
        borderWidth: 1,
        backgroundColor: '#FFFFFF',
        shadow: false
      },
      series: [
        { name: '', color: colors[0], data: [] },
        { name: '', color: colors[1], data: [] }
      ],
    };
  }

  ngOnInit()
  {
    const campaignName = this.route.snapshot.queryParams['campaign'];

    Observable.zip(
      this.campaignService.getCampaign(campaignName),
      this.campaignService.getCampaignSummary(campaignName)
    ).subscribe(([campaign, summary]) => {
      this.campaign = new Campaign(campaign);
      this.coupons = summary.cardCoupons;
      this.spentBudget = summary.budget;
      this.budgetPercentage = Math.min(100, Math.round(summary.budget * 100 / campaign.budget));
      this.loadCharts(campaignName);
    });
  }

  chartInstance(chart: { instance, options }, chartInstance)
  {
    chart.instance = chartInstance;
  }

  loadCharts(campaignName: string)
  {
    this.campaignService.getCampaignSummaryData(campaignName).subscribe(res => {
      this.totalCustomers = 0;

      res.key.forEach((serieName, i) => {
        this.charts.summary.options.series[i].name = res.keyView[i];
        res.campaignSummaryMainModels.forEach(data => {
          this.charts.summary.options.xAxis.categories.push(data.cluster);
          this.totalCustomers += +data.totalCustomers;
          this.charts.summary.options.series[i].data.push(+data[serieName]);
        });
      });

      this.charts.summary.options.chart.height = 75 + res.campaignSummaryMainModels * 50;
      this.charts.summary.instance.update(this.charts.summary.options);
    });

    this.campaignService.getCostPerTypeData(campaignName).subscribe(res => {
      res.forEach(data => {
        this.charts.costPerType.options.series[0].data.push({
          name: data.type,
          y: parseFloat(data.percentage)
        });
      });

      this.charts.costPerType.instance.update(this.charts.costPerType.options);
    });

    this.campaignService.getCampaignCostPerChannelData(campaignName).subscribe(res => {
      res.keyShow.forEach((serieName, i) => {
        this.charts.costPerChannel.options.xAxis.categories.push('Campaign ' + res.costPerChannelModel.category);
        this.charts.costPerChannel.options.series[i].name = serieName;
        this.charts.costPerChannel.options.series[i].data.push(parseInt(res.costPerChannelModel[serieName]));
      });
      this.charts.costPerChannel.instance.update(this.charts.costPerChannel.options);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign/summary/summary.component.ts